import React from 'react'
import { connect } from 'react-redux'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import OverrideModalDetails from './OverrideModalDetails'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const OverrideModal = ({ modalLoading, modal, toggleModal, sendOverride, row, approvalUser }) => {
  if (modalLoading) {
    return (
      <Modal size="lg" isOpen={modal}>
        <ModalHeader>
          <PageHeading small>Override Change</PageHeading>
        </ModalHeader>
        <ModalBody>
          <LoadingSpinner />
        </ModalBody>
      </Modal>
    )
  } else if (approvalUser !== null && approvalUser !== undefined) {
    return (
      <OverrideModalDetails
        isOpen={modal}
        toggle={toggleModal}
        sendOverride={sendOverride}
        row={row}
        approvalUser={approvalUser}
      />
    )
  } else return null
}

const mapStateToProps = (state) => ({
  modalLoading: state.approval.modalLoading,
  loading: state.approval.loading,
  approvalUser: state.approval.approvalUser,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(OverrideModal)
